import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { MarqueeStrip } from "@/components/landing/MarqueeStrip";
import { ProofCarousel } from "@/components/landing/ProofCarousel";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { Benefits } from "@/components/landing/Benefits";
import { BeyondFirstAd } from "@/components/landing/BeyondFirstAd";
import { Faq } from "@/components/landing/Faq";
import { BriefForm } from "@/components/landing/BriefForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="relative bg-[#050505] text-white">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <ProofCarousel />
      <HowItWorks />
      <Pricing />
      <Benefits />
      <BeyondFirstAd />
      <Faq />
      <BriefForm />
      <Footer />
    </main>
  );
}
